import z from "zod";
import { CommunicationType, DocumentType } from "../../../../types";
import emptyHtmlToNull from "../../../../utils/emptyHtmlToNull";

export type Document = z.infer<typeof documentsSchema>;

const documentsSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  file_url: z.string().nullable(),
  document_type_id: z.string().nullable().optional(),
  type: z.custom<DocumentType>().nullable().optional(),
  pendingFile: z.custom<File>().optional(),
})

export const formSchema = z.object({
  date: z.date('Ce champ est obligatoire').transform(val => val.toISOString()),
  title: z.string().trim().optional(),
  contact_name: z.string().trim().optional(),
  provider_name: z.string().trim().optional(),
  provider_id: z.string().nullable().optional(),
  comment: z.string().trim().optional().transform(emptyHtmlToNull),
  documents: z.array(documentsSchema),
  amount: z.number().optional(),
  communication_type: z.custom<CommunicationType>().optional(),
});

export type FormInputs = z.input<typeof formSchema>;
export type FormValues = z.infer<typeof formSchema>;
